import React, { useEffect } from 'react';
import { actions } from 'redux/actions';
import { useSelector } from 'react-redux';
import Shared from 'screens/shared';
import CreateForm from 'screens/shared/nat-gateway/create';
import { ROUTE } from 'constant';
import { ACTIONS_TYPES } from 'redux/helper';
import ForwardingRules from './forwarding-rule';

export default ({ match }) => {
  const { dcId, id } = match.params;
  const { [ACTIONS_TYPES.NAT_GATEWAY.GET]: natGateway } = useSelector((e) => e);
  const { entities = {}, properties = {} } = natGateway || {};

  useEffect(() => {
    actions.natGateway.get({ dcId, id });
  }, [dcId, id]);

  const renderProperties = [
    ['Public IPs', <Shared.utilities.IPs ips={properties?.publicIps} />],
    ['LANs', <Shared.widgets.Properties
      title=""
      margin={0}
      className="shadow-2"
      properties={properties?.lans?.map?.((e) => ([
        <Shared.utilities.LAN id={e?.id} />,
        <Shared.utilities.IPs ips={e?.gatewayIps} />,
      ]))}
    />],
  ];

  return (
    <Shared.widgets.Page
      route={ROUTE.DASHBOARD.NAT_GATEWAY}
      strapIcon="sitemap"
      strapTitle={properties?.name}
      onDelete={() => actions.natGateway.delete({ dcId, id })}
      editForm={<CreateForm item={{ id, ...properties }} dcId={dcId} isEdit />}
      editAction={ACTIONS_TYPES.NAT_GATEWAY.UPDATE}
    >
      <Shared.widgets.Properties properties={renderProperties} />
      <ForwardingRules items={entities?.rules?.items} {...{ dcId, id, ips: properties?.publicIps }} />
    </Shared.widgets.Page>
  );
};
